<div class="featured-card">
  <div class="card-image-container">
    <img [src]="card.imageUrl || IMAGE_PLACEHOLDER" [alt]="card.name" class="card-image" />
    @if (card.causeName) {
      <span class="cause-badge">{{ (card.causeName || '') | translateLang }}</span>
    }
  </div>
  <div class="card-content" [ngStyle]="{'height.px': contentHeight}">
    <div class="card-text">
      <h3
        class="project-name"
        appTruncateWithTooltip
        [tooltipText]="card.name ?? undefined"
        [tooltipShowDelay]="100"
        [tooltipHideDelay]="500">
        {{ (card.name || '') | translateLang }}
      </h3>
      @if (showOrgInfo) {
        <div class="org-info">
          <img src="/assets/images/icons/settings/portfolio.svg" alt="" class="org-icon" />
          <span
            class="org-name"
            appTruncateWithTooltip
            [tooltipText]="card.organisationName ?? undefined"
            [tooltipShowDelay]="100"
            [tooltipHideDelay]="500">
            {{ (card.organisationName || '') | translateLang }}
          </span>
        </div>
      }
      <p
        class="description"
        appTruncateWithTooltip
        [lineClamp]="4"
        [maxWidth]="600"
        [tooltipText]="card.description ?? undefined"
        [tooltipShowDelay]="100"
        [tooltipHideDelay]="500">
        {{ (card.description || '') | translateLang }}
      </p>
    </div>

    @if (showProgress) {
      <div class="progress-section">
      <div class="progress-header">
        <p class="donation-label">{{ 'home.cards.tab.progress.donations' | translateLang }}</p>
        <p class="percentage">{{ progressPercentage | number:'1.0-0' }}%</p>
      </div>
      <div class="progress-bar-container">
        <div class="progress-bar-inactive"></div>
        <div class="progress-bar-active" [style.width.%]="progressPercentage"></div>
      </div>
      <div class="amounts">
        <div class="raised">
          <span class="label">{{ 'home.cards.tab.progress.raised' | translateLang }} :</span>
          <span class="amount">{{ resolvedCurrencySymbol }}{{ card.amountRaisedToDate }}</span>
        </div>
        <div class="goal">
          <span class="label">{{ 'home.cards.tab.progress.goal' | translateLang }} :</span>
          <span class="amount">{{ resolvedCurrencySymbol }}{{ card.totalProjectBudget }}</span>
        </div>
      </div>
    </div>
    }

    <div class="card-actions">
      <!-- Give button/link -->
      <span
        class="give-wrapper"
        [class.give-wrapper--disabled]="!card.giveLink"
        [customTooltip]="!card.giveLink ? ('common.give.no_link_tooltip' | translateLang) : null">
        @if (giveUrl) {
          <a
            [href]="giveUrl"
            [class.disabled]="!card.giveLink"
            class="give-button give-link"
            (click)="onGiveClick($event)"
            target="_blank"
            rel="noopener noreferrer">
            <img src="/assets/images/home/Icons/give.png" alt="" class="button-icon" />
            {{ 'home.cards.card.give' | translateLang }}
          </a>
        } @else {
          <button
            [disabled]="!card.giveLink"
            class="give-button"
            (click)="onGiveClick()">
            <img src="/assets/images/home/Icons/give.png" alt="" class="button-icon" />
            {{ 'home.cards.card.give' | translateLang }}
          </button>
        }
      </span>

      <!-- Learn more button/link -->
      @if (learnMoreUrl) {
        <a
          [href]="learnMoreUrl"
          class="learn-more-button learn-more-link"
          (click)="onLearnMoreClick($event)"
          target="_blank"
          rel="noopener noreferrer">
          {{ 'home.cards.card.learn' | translateLang }}
        </a>
      } @else {
        <button class="learn-more-button" (click)="onLearnMoreClick()">
          {{ 'home.cards.card.learn' | translateLang }}
        </button>
      }
    </div>
  </div>
</div>
